<!-- 营销中心 平台营销工具 平台卡券管理 会员权益卡管理 新增 -->
<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm">
    <ykc-form-item label="会员权益卡名称" prop="cardCouponName">
      <ykc-input
        :disabled="isEdit"
        v-model="ruleForm.cardCouponName"
        placeholder="对外名称"
        maxlength="50"></ykc-input>
    </ykc-form-item>
    <ykc-form-item label="对外名称" prop="outName">
      <ykc-input v-model="ruleForm.outName" placeholder="请输入对外名称" maxlength="50"></ykc-input>
    </ykc-form-item>
    <!-- <ykc-form-item label="电费优惠" prop="powerPercentage">
      <ykc-input v-model="ruleForm.powerPercentage" maxlength="3" placeholder="请输入电费优惠">
        <template slot="prepend">抵扣比例</template>
        <template slot="append">%</template>
      </ykc-input>
    </ykc-form-item> -->
    <ykc-form-item prop="servicePercentage" label="服务费优惠">
      <ykc-input
        v-model="ruleForm.servicePercentage"
        :disabled="isEdit"
        maxlength="3"
        placeholder="如果是打8折，填写20%">
        <template slot="prepend">抵扣比例</template>
        <template slot="append">%</template>
      </ykc-input>
    </ykc-form-item>
    <ykc-form-item label="会员权益卡面额" prop="faceValue">
      <ykc-input
        :disabled="isEdit"
        v-model="ruleForm.faceValue"
        placeholder="请输入会员权益卡面额"
        maxlength="10">
        <template slot="append">元</template>
      </ykc-input>
    </ykc-form-item>
    <ykc-form-item label="会员权益卡数量" prop="stockNum" v-if="ruleForm.useType === '1'">
      <ykc-input
        :disabled="isEdit"
        v-model="ruleForm.stockNum"
        placeholder="请输入会员权益卡数量"
        maxlength="8">
        <template slot="append">张</template>
      </ykc-input>
    </ykc-form-item>
    <ykc-form-item label="有效时间类型" prop="effectiveTimeType" v-if="ruleForm.useType === '1'">
      <ykc-radio
        :disabled="isEdit"
        :data="getDic.use_time_type"
        v-model="ruleForm.effectiveTimeType"
        @change="changeDateAvailable"></ykc-radio>
    </ykc-form-item>
    <ykc-form-item
      label="有效时间"
      prop="afterReceiveDay"
      v-if="ruleForm.effectiveTimeType === '1'">
      <ykc-input :disabled="isEdit" v-model="ruleForm.afterReceiveDay" placeholder="请输入相对时间">
        <template slot="prepend">领取后</template>
        <template slot="append">天</template>
      </ykc-input>
    </ykc-form-item>
    <ykc-form-item label="有效时间" prop="termDate" v-if="ruleForm.effectiveTimeType === '2'">
      <ykc-date-picker
        :disabled="isEdit"
        limitDate="limitBefore"
        format="yyyy-MM-dd HH:mm"
        v-model="ruleForm.termDate"></ykc-date-picker>
    </ykc-form-item>
    <ykc-form-item
      class="file-error img-error"
      label="会员权益卡图片"
      bottomTip="温馨提示：只能上传小于1M的图片，不上传将显示默认图片"
      prop="image">
      <ykc-upload
        :size="1"
        ref="ykcupload"
        :file="ruleForm.setFile"
        @handleRemove="handleRemove"
        :checkInfo="{ typeMess: '文件格式错误，请重新导入', sizeMess: '文件大小不超过' }"
        @handleChange="handleUpload"></ykc-upload>
    </ykc-form-item>
    <template v-if="ruleForm.useType === '1'">
      <ykc-form-item prop="scopeType" label="可用维度" required>
        <ykc-radio
          :data="availableList"
          v-model="ruleForm.scopeType"
          @change="changeAvailable"></ykc-radio>
      </ykc-form-item>
      <ykc-form-item prop="cityList" label="选择城市" v-if="ruleForm.scopeType === '1'">
        <ykc-tree
          v-model="checkAll"
          ref="operaCityTree"
          :data="treeData"
          :props="treeProps"
          :nodeKey="treeNodeKey"
          @check-change="handleCityTreeCheckChange"></ykc-tree>
      </ykc-form-item>
      <ykc-form-item prop="stationIdList" label="选择电站" v-if="ruleForm.scopeType === '2'">
        <ykc-tree
          v-model="checkAll"
          ref="operaTree"
          :data="treeData"
          :props="treeProps"
          :nodeKey="treeNodeKey"
          @check-change="handleTreeCheckChange"></ykc-tree>
      </ykc-form-item>
    </template>
  </ykc-form>
</template>
<script>
  import { marketManage, treeUtils, uploadUtils } from '@/service/apis';
  import { sessionGetItem } from '@/utils';
  import regexpObj from '@/utils/regexp';

  export default {
    name: 'CreditCardManageAdd',
    props: {
      cardCouponId: {
        type: String,
      },
    },
    data() {
      return {
        availableList: [
          {
            id: '1',
            name: '按城市',
          },
          {
            id: '2',
            name: '按站点',
          },
          {
            id: '4',
            name: '全部站点',
          },
        ],
        checkAll: 'true',
        defaultimage: require('@/assets/images/card.png'),
        ruleForm: {
          servicePreferentialWay: '1',
          powerPreferentialWay: '1',
          useType: '1',
          scopeType: '1',
          cardCouponName: '', // 会员权益卡名称
          image: '', // 会员权益卡图片
          outName: '', // 对外名称
          stockNum: '', // 总数
          deductionType: '2', // 会员权益卡类型 1服务费 2电费 3总电费 字典deduction_type
          faceValue: '', // 优惠金额/折扣比
          amountLimit: '', // 使用条件
          effectiveTimeType: '3', // 时间类型 use_time_type
          servicePercentage: '',
          afterReceiveDay: '', // 使用时间几天后到期
          effectiveStartDate: '', // 期限开始时间
          effectiveEndDate: '', // 期限结束时间
          termDate: [],
          stationIdList: [],
          cityList: [],
          setFile: [],
        },
        rules: {
          cardCouponName: [
            { required: true, message: '请输入会员权益卡名称', trigger: 'blur' },
            {
              pattern: regexpObj.regexp.input.nameType.regexp,
              trigger: 'blur',
              message: regexpObj.regexp.input.nameType.errorTips.error('会员权益卡名称'),
            },
            { validator: this.onlyCheckName, trigger: 'blur' },
          ],
          outName: [
            { required: true, message: '请输入对外名称', trigger: 'blur' },
            {
              pattern: regexpObj.regexp.input.nameType.regexp,
              trigger: 'blur',
              message: regexpObj.regexp.input.nameType.errorTips.error('对外名称'),
            },
          ],
          // powerPercentage: [
          //   {
          //     required: true,
          //     message: '请输入电费优惠',
          //     trigger: 'blur',
          //   },
          //   {
          //     pattern: regexpObj.regexp.input.percentNumberType.regexp,
          //     trigger: 'blur',
          //     message: regexpObj.regexp.input.percentNumberType.errorTips.error('电费优惠', 100),
          //   },
          // ],
          servicePercentage: [
            {
              required: true,
              message: '请输入服务费优惠',
              trigger: 'blur',
            },
            {
              pattern: regexpObj.regexp.input.percentNumberType.regexp,
              trigger: 'blur',
              message: regexpObj.regexp.input.percentNumberType.errorTips.error('服务费优惠', 100),
            },
          ],
          faceValue: [
            { required: true, message: '请输入优惠券面额', trigger: 'blur' },
            {
              pattern: regexpObj.regexp.input.amountFourNumberType.regexp,
              trigger: 'blur',
              message: regexpObj.regexp.input.amountFourNumberType.errorTips.error(
                '优惠券面额',
                9999.9999
              ),
            },
            {
              validator: (rule, value, callback) => {
                if (
                  this.ruleForm.amountLimit !== '' &&
                  parseInt(value, 10) > parseInt(this.ruleForm.amountLimit, 10)
                ) {
                  callback('面额需小于等于费用抵扣条件');
                } else {
                  this.$refs.ruleForm.clearValidate('faceValue');
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],
          stockNum: [
            { required: true, message: '请输入会员权益卡数量', trigger: 'blur' },
            {
              pattern: regexpObj.regexp.input.integerNumberType.regexp,
              trigger: 'blur',
              message: regexpObj.regexp.input.integerNumberType.errorTips.error(
                '会员权益卡数量',
                99999999
              ),
            },
          ],
          deductionType: [{ required: true, message: '请选择费用抵扣类型', trigger: 'change' }],
          amountLimit: [
            { required: true, message: '请输入费用抵扣条件', trigger: 'blur' },
            {
              pattern: regexpObj.regexp.input.amountNumberType.regexp,
              trigger: 'blur',
              message: '请输入正确的费用抵扣条件（范围：0.01~999.99）',
            },
            {
              validator: (rule, value, callback) => {
                if (
                  this.ruleForm.faceValue !== '' &&
                  parseInt(value, 10) < parseInt(this.ruleForm.faceValue, 10)
                ) {
                  callback('费用抵扣条件需大于等于优惠券面额');
                } else {
                  this.$refs.ruleForm.clearValidate('amountLimit');
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],
          effectiveTimeType: [{ required: true, message: '请选择有效时间类型', trigger: 'change' }],
          afterReceiveDay: [
            { required: true, message: '请输入相对时间', trigger: 'blur' },
            {
              pattern: regexpObj.regexp.input.integerNumberType.regexp,
              trigger: 'blur',
              message: regexpObj.regexp.input.integerNumberType.errorTips.error(
                '相对时间',
                9999999
              ),
            },
          ],
          termDate: [{ required: true, trigger: 'change', message: '请选择活动时间' }],
          stationIdList: [{ required: true, message: '请选择电站', trigger: 'change' }],
          cityList: [{ required: true, message: '请选择城市', trigger: 'change' }],
        },
        treeCityData: [],
        treeCityProps: {
          label: 'name',
          children: 'subNodes',
          disabled: 'disabled',
        },
        treeCityNodeKey: 'id',
        treeOperatorData: [],
        treeOperatorProps: {
          label: 'stationName',
          children: 'stationTreeVOList',
          disabled: 'disabled',
        },
        treeOperatorNodeKey: 'stationId',
        treeStationData: [],
        treeStationProps: {
          label: 'name',
          children: 'childList',
          disabled: 'disabled',
        },
        treeStationNodeKey: 'id',
        getDic: {
          deduction_type: [
            { id: '1', name: '服务费' },
            { id: '2', name: '电费' },
            { id: '3', name: '总费用' },
          ],
          use_time_type: [
            { id: '1', name: '相对时间' },
            { id: '2', name: '绝对时间' },
            { id: '3', name: '无到期时间' },
          ],
        },
      };
    },
    computed: {
      isEdit() {
        return !!this.cardCouponId;
      },
      treeData() {
        if (this.ruleForm.scopeType === '1') {
          return this.treeCityData;
        }
        if (this.ruleForm.scopeType === '2') {
          return this.treeOperatorData;
        }
        return [];
      },
      treeProps() {
        if (this.ruleForm.scopeType === '1') {
          return this.treeCityProps;
        }
        if (this.ruleForm.scopeType === '2') {
          return this.treeOperatorProps;
        }
        if (this.ruleForm.scopeType === '3') {
          return this.treeStationProps;
        }
        return {
          label: 'name',
          children: 'subTree',
          disabled: 'disabled',
        };
      },
      treeNodeKey() {
        if (this.ruleForm.scopeType === '1') {
          return this.treeCityNodeKey;
        }
        if (this.ruleForm.scopeType === '2') {
          return this.treeOperatorNodeKey;
        }
        if (this.ruleForm.scopeType === '3') {
          return this.treeStationNodeKey;
        }
        return 'id';
      },
    },
    created() {
      this.getCouponAndTree();
    },
    methods: {
      changeUseType(val) {
        if (val === '2') {
          this.ruleForm.effectiveTimeType = '1';
          this.ruleForm.scopeType = '4';
        }
      },

      handleTreeCheckChange() {
        this.ruleForm.stationIdList = this.$refs.operaTree.getCheckedKeys(true);
      },

      handleCityTreeCheckChange() {
        const selectedDatas = [];
        const items = this.$refs.operaCityTree.getCheckedNodes(true);
        items.forEach(item => {
          selectedDatas.push({
            cityId: item.id,
            cityName: item.name,
            provinceId: item.parentId,
          });
        });
        this.ruleForm.cityList = selectedDatas;
      },

      handleRemove() {
        console.log('handleRemove called');
        this.ruleForm.file = undefined;
        this.validateFormFile();
      },
      submitCityList(cityList) {
        return cityList.map(item => ({
          provinceId: item[0],
          cityId: item[1],
        }));
      },
      /**
       * 获取文件
       */
      handleUpload(file, fileList, isCheck) {
        if (isCheck) {
          const formData = new FormData();
          const param = {
            file: file.raw,
            bizName: '',
          };
          console.log('param', param);
          // 处理入参格式
          Object.entries(param).forEach(([k, v]) => {
            formData.append(k, v);
          });
          uploadUtils.uploadImg(formData).then(res => {
            this.ruleForm.image = res;
            this.$refs.ruleForm.validateField('ykcupload');
          });
        }
      },

      /**
       * 获取会员权益卡
       */
      getCouponAndTree() {
        const requests = [];
        const cityTreeRequest = treeUtils.getDistrict({ level: '3' });
        const operatorTreeRequest = treeUtils.operatorStations({});
        requests.push(cityTreeRequest);
        requests.push(operatorTreeRequest);
        Promise.all(requests)
          .then(([cityTreeData, operatorTreeData]) => {
            const params = cityTreeData.districts;
            this.treeCityData = params;
            this.treeOperatorData = this.transOperatorStations(operatorTreeData);
            if (this.isEdit) {
              this.getDetail();
            }
          })
          .catch(() => {
            this.treeCityData = [];
            this.treeOperatorData = [];
          });
      },
      // 处理商户数据
      transOperatorStations(listData = []) {
        const kayMap = { operatorName: 'stationName', operatorId: 'stationId' };
        const setEmpty = (data, keyMap) => {
          const objs = Object.keys(data).reduce((newData, key) => {
            const newKey = keyMap[key] || key;
            newData[newKey] = data[key];
            return newData;
          }, {});
          return objs;
        };

        return listData.map(item => {
          return setEmpty(item, kayMap);
        });
      },
      /**
       * 保存操作
       */
      async beforeDrawer(cb) {
        if (this.ruleForm.termDate.length === 2) {
          this.ruleForm.effectiveStartDate = `${this.ruleForm.termDate[0]}`;
          this.ruleForm.effectiveEndDate = `${this.ruleForm.termDate[1]}`;
        }
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            const reqParams = {
              ...this.ruleForm,
              powerPercentage: '0',
              undertakerType: '1',
              cardCouponType: '3',
              operatorBy: sessionGetItem('accountNo'),
              undertakerId: 'qiehuanid',
            };
            if (this.ruleForm.scopeType === '1') {
              // 城市
              reqParams.stationIdList = [];
            } else {
              // 全国
              reqParams.cityList = [];
            }
            if (this.ruleForm.effectiveTimeType === '3') {
              this.ruleForm.effectiveStartDate = '';
              this.ruleForm.effectiveEndDate = '';
              this.ruleForm.afterReceiveDay = '';
            }
            console.log(reqParams);
            if (this.isEdit) {
              // 编辑
              reqParams.cardCouponId = this.cardCouponId;
              marketManage.edit(reqParams).then(() => {
                cb && cb();
                this.$emit('finish');
              });
            } else {
              // 新增
              marketManage.add(reqParams).then(() => {
                cb && cb();
                this.$emit('finish');
              });
            }
          }
        });
      },
      /**
       * 活动名称校验
       */
      onlyCheckName(rule, value, callback) {
        if (this.isEdit) {
          callback();
          return;
        }
        marketManage
          .unique({
            cardCouponName: value,
            undertakerType: '1',
            cardCouponType: '3',
          })
          .then(() => {
            callback();
          })
          .catch(err => {
            callback(err.data?.resultDesc);
          });
      },
      changeAvailable() {
        // 清楚选择的电站数据
        this.ruleForm.stationIdList = [];
        this.ruleForm.cityList = [];
      },
      changeDateAvailable() {
        // 清楚时间选择
        this.ruleForm.afterReceiveDay = '';
        this.ruleForm.effectiveStartDate = '';
        this.ruleForm.effectiveEndDate = '';
        this.ruleForm.termDate = [];
      },
      /**
       * 获取详情数据
       */
      getDetail() {
        marketManage
          .detail({ cardCouponId: this.cardCouponId, undertakerType: '1', cardCouponType: '3' })
          .then(res => {
            console.log('result', res);
            this.ruleForm = {
              servicePreferentialWay: res.servicePreferentialWay,
              powerPreferentialWay: res.powerPreferentialWay,
              useType: res.useType,
              scopeType: res.scopeType,
              cardCouponName: res.cardCouponName, // 会员权益卡名称
              outName: res.outName, // 对外名称
              stockNum: res.stockNum, // 总数
              deductionType: res.deductionType, // 会员权益卡类型 1服务费 2电费 3总电费 字典deduction_type
              faceValue: res.faceValue, // 优惠金额/折扣比
              amountLimit: res.amountLimit, // 使用条件
              effectiveTimeType: res.effectiveTimeType, // 时间类型 use_time_type
              afterReceiveDay: res.afterReceiveDay, // 使用时间几天后到期
              servicePercentage: res.servicePercentage,
              effectiveStartDate: res.effectiveStartDate || '', // 期限开始时间
              effectiveEndDate: res.effectiveEndDate || '', // 期限结束时间
              image: res.image || '', // 会员权益卡图片
              termDate:
                res.effectiveStartDate && res.effectiveEndDate
                  ? [res.effectiveStartDate, res.effectiveEndDate]
                  : [],
              stationIdList: res.stationIdList || [],
              cityList: res.cityList.map(item => [item.provinceId, item.cityId]) || [],
            };
            this.$nextTick(() => {
              this.$refs.operaTree.setCheckedKeys(res.stationIdList || [], true);
            });
          });
      },
    },
  };
</script>
<style lang="scss">
  .has-time.ykc-date-picker,
  .has-time.hourHide {
    .el-picker-panel__footer .el-button.el-button--text {
      display: none;
    }
  }
  .el-select-dropdown__list {
    min-width: 94px;
    // font-size: 12px;
    // color: #000;
  }
  .couponValue {
    display: flex;
    justify-content: space-between;
  }
</style>
